import React, { lazy, Suspense, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header";
import CacheBuster from "react-cache-buster";
import { CookieSetting } from "cookiesetting-component";
import appversion from "../package.json";

const Footer = lazy(() => import("./components/CommenFooterComponent/index.js"));
const Joaquin = lazy(() => import("./components/Calfa/Calfa.js"));
const Assistance = lazy(() =>
  import("./components/ExploreAssistance/Assistance.js")
);
const Banner = lazy(() => import("./components/Banner/Banner"));
const Market = lazy(() => import("./components/Market/Market.js"));

export default function App(setShowModal, setLoanOfficerUid, setLoanPurpose) {
  const [bannerData, setBannerData] = useState();
  const appVersion = appversion.version;

  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <div className="bodyContainer">
        <Header fetchpriority="high" />
        <>
          <Suspense fallback={<div />}>
            <Banner />
          </Suspense>
          <Suspense fallback={<div />}>
            <Market />
          </Suspense>

          <Suspense fallback={<div />}>
            <Assistance />
          </Suspense>
          <Suspense fallback={<div />}>
            <Joaquin />
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
          <CookieSetting 
            privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
            configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
            analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
        </>
      </div>
    </CacheBuster>
  );
}
